module.exports = __webpack_public_path__ + "img/oven-fried-chicken-with-skinny-french-fries.ac52160e.jpg";